import { LOADING_STATUS } from "@/helpers/loadingStatus";
import httpClient from "@/http/httpClient";
import store from "@/store";
import _ from "lodash";
import moment from "moment";
export default {
  namespaced: true,
  state: {
    loadingStatus: "",
    result: [],
    selectedTypes: [],
    selectedGrades: [],
    selectedStyles: [],
    productTypes: [],
    productStyles: [],
    productGrades: [],
    groupBy: "none",
    date: "",
    iResult: [],
    individualType: "",
    individualGrade: "",
    individualStyle: "",
    individualGroup: "",
    individualParam: "",
  },
  getters: {
    getParams(state) {
      const params = {};
      if (state.selectedStyles.length) {
        params["style"] = state.selectedStyles.map((i) => i).join(",");
      }

      if (state.selectedTypes.length) {
        params["type"] = state.selectedTypes.map((i) => i).join(",");
      }

      if (state.selectedGrades.length) {
        params["grade"] = state.selectedGrades.map((i) => i).join(",");
      }

      if (state.date && state.date !== "") {
        params["date"] = state.date;
      }

      if (state.groupBy && state.groupBy !== "none") {
        params["group_by"] = state.groupBy;
      }

      return params;
    },
  },
  mutations: {
    reset(state) {
      state.result = [];
      state.iResult = [];
    },
    setLoadingStatus(state, payload) {
      state.loadingStatus = payload;
    },
    setResult(state, payload) {
      if (state.groupBy === "none") {
        state.result = [...state.result, ...payload];
      } else {
        state.result = payload;
      }
    },
    setIndividualResult(state, payload) {
      // state.iResult = [];
      state.iResult.push(payload);
    },
    setProductTypes(state, payload) {
      state.productTypes = payload;
    },
    setProductStyles(state, payload) {
      state.productStyles = payload;
    },
    setProductGrades(state, payload) {
      state.productGrades = payload;
    },
    setIndividualResultParams(state, payload) {
      let group = payload[0];
      let type = payload[1];
      let style = payload[2];
      let grade = payload[3];

      let queryParam = "";
      switch (group) {
        case "type":
          queryParam = "?type=" + type;
          break;
        case "type-style":
          queryParam = "?type=" + type + "&style=" + style;
          break;
        case "style":
          queryParam = "?style=" + style;
          break;
        case "style-grade":
          queryParam = "?style=" + style + "&grade=" + grade;
          break;
      }
      state.individualParam = queryParam;
    },
    setFilterDate(state, payload) {
      let dateString = "";
      state.result = [];
      state.totalAmount = 0;
      switch (payload) {
        case "today":
          dateString = moment().format("YYYY-MM-DD");
          break;
        case "yesterday":
          dateString = moment().subtract(1, "days").format("YYYY-MM-DD");
          break;
        case "week":
          dateString = moment().clone().startOf("isoWeek").format("YYYY-MM-DD");
          break;
        case "last_week":
          dateString = moment().subtract(1, "weeks").format("YYYY-MM-DD");
          break;
        case "month":
          dateString = moment().clone().startOf("month").format("YYYY-MM-DD");
          break;
        case "last_month":
          dateString = moment()
            .subtract(1, "months")
            .startOf("month")
            .format("YYYY-MM-DD");
          break;
        case "quarter":
          dateString = moment()
            .quarter(moment().quarter())
            .startOf("quarter")
            .format("YYYY-MM-DD");
          break;
        case "last_quarter":
          dateString = moment()
            .subtract(1, "Q")
            .startOf("Q")
            .format("YYYY-MM-DD");
          break;
        case "year":
          dateString = moment().startOf("year").format("YYYY-MM-DD");
          break;
        case "last_year":
          dateString = moment()
            .subtract(1, "years")
            .startOf("year")
            .format("YYYY-MM-DD");
          break;
        case "custom":
          dateString = dateString;
          break;
      }
      state.date = dateString;
    },
    setSelectedTypes(state, payload) {
      state.selectedTypes = [];
      state.selectedTypes = payload;
    },
    setSelectedStyles(state, payload) {
      state.selectedStyles = [];
      state.selectedStyles = payload;
    },
    setSelectedGrades(state, payload) {
      state.selectedGrades = [];
      state.selectedGrades = payload;
    },
    setGroupBy(state, payload) {
      state.individualParam = "";
      state.iResult = [];
      state.result = payload !== "none" ? {} : [];
      state.groupBy = payload;
    },
  },
  actions: {
    async fetchAllTypes({ commit, state, dispatch, getters }) {
      commit(
        "setLoadingStatus",
        !_.isEmpty(state.result)
          ? LOADING_STATUS.REFRESHING
          : LOADING_STATUS.FETCHING
      );
      try {
        const response = await httpClient.get("reports/products/types");
        commit("setProductTypes", response.data.data);
        return true;
      } catch (error) {
        console.error("Error on Fetch product types: ", error);
        store.commit("errorsModal/openModal", error.response.data.errors);
        return false;
      }
    },
    async fetchAllStyles({ commit, state, dispatch, getters }) {
      commit(
        "setLoadingStatus",
        !_.isEmpty(state.result)
          ? LOADING_STATUS.REFRESHING
          : LOADING_STATUS.FETCHING
      );
      try {
        const response = await httpClient.get("reports/products/styles");
        commit("setProductStyles", response.data.data);
        return true;
      } catch (error) {
        console.error("Error on Fetch product styles: ", error);
        store.commit("errorsModal/openModal", error.response.data.errors);
        return false;
      }
    },
    async fetchAllGrades({ commit, state, dispatch, getters }) {
      commit(
        "setLoadingStatus",
        !_.isEmpty(state.result)
          ? LOADING_STATUS.REFRESHING
          : LOADING_STATUS.FETCHING
      );
      try {
        const response = await httpClient.get("reports/products/grades");
        commit("setProductGrades", response.data.data);
        return true;
      } catch (error) {
        console.error("Error on Fetch product grades: ", error);
        store.commit("errorsModal/openModal", error.response.data.errors);
        return false;
      }
    },
    async fetchAllProductsWithFilters({ commit, state, dispatch, getters }) {
      commit(
        "setLoadingStatus",
        !_.isEmpty(state.result)
          ? LOADING_STATUS.REFRESHING
          : LOADING_STATUS.FETCHING
      );
      try {
        const response = await httpClient.get("reports/sales-by-product", {
          params: getters.getParams,
        });
        commit("setResult", response.data.data);
        commit("setLoadingStatus", LOADING_STATUS.COMPLETED);
        return true;
      } catch (error) {
        console.error("Error on Fetch customer: ", error);
        commit("setLoadingStatus", LOADING_STATUS.FAILED);
        store.commit("errorsModal/openModal", error.response.data.errors);
        return false;
      }
    },
    async fetchIndividualProductInfo({ commit, state, dispatch, getters }) {
      commit(
        "setLoadingStatus",
        !_.isEmpty(state.result)
          ? LOADING_STATUS.REFRESHING
          : LOADING_STATUS.FETCHING
      );
      try {
        const response = await httpClient.get(
          "reports/sales-product" + state.individualParam
        );
        commit("setIndividualResult", response.data.data);
        commit("setLoadingStatus", LOADING_STATUS.COMPLETED);
        return true;
      } catch (error) {
        console.error("Error on Fetch data: ", error);
        commit("setLoadingStatus", LOADING_STATUS.FAILED);
        store.commit("errorsModal/openModal", error.response.data.errors);
        return false;
      }
    },
  },
};
